import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { NavigationService } from '../../services/navigation.service';
import { EnrollmentService } from '../../services/enrollment.service';
import { MatDialog } from '@angular/material/dialog';
import { ForgotConfirmationComponent } from '../../reusable-components/forgot-confirmation/forgot-confirmation.component';
import { ModalService } from 'src/app/services/modal.service';
import { HttpClient } from '@angular/common/http';
import { PersistenceService } from '../../services/persistence.service';
import { Router } from '@angular/router';
import { RememberService } from 'src/app/services/remember.service';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentService } from '../../services/environment.service';
import { LogService } from 'src/app/services/log.service';

@Component({
    templateUrl: './oauth.component.html',
    styleUrls: ['./oauth.component.scss'],
    standalone: false
})
export class OauthComponent implements OnInit {
  loginID;
  regcode;

  oa;
  oaLowerProps={};

  theToken = false;
  confirmationNo;
  emailAddress;
  errorMsg;
  fordSiteCode;
  firstname;
  lastname;
  fordJobRole;
  CDSID;
  TrackFocusDirective;
  isFormCompleted = false;
  isSubmitting = true;
  rememberme=false;
  foundcookie=false;
  constructor(
    private authenticationService: AuthenticationService,
    private navigationService: NavigationService,
    private enrollmentService: EnrollmentService,
    public dialog: MatDialog,
    public modalService: ModalService,
    private persistenceService: PersistenceService,
    private router: Router,
    private rememberService: RememberService,
    private route: ActivatedRoute,
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private logService: LogService,
  ) {
    //this.persistenceService.clear();

   }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
        console.log('routeparams',params);

      if(params["code"])
      {

      const serviceurl = this.environmentService.getEnvironmentUrl(
        'service/oauth/?code=' + params["code"] + "&session_state=" +  params["session_state"] );
      this.http.get(serviceurl).subscribe({
        next: (data) => {
        this.oa = data;
              Object.keys(data).forEach(key=>{ // creater a map [ENTRA property in lower case] : true ENTRA property name
                this.oaLowerProps[key.toLowerCase()]=key;
              });
              this.fordSiteCode= this.givemeEntraProp('fordSiteCode'); // this.cookieLogin = this.oa.fordSiteCode;
              this.firstname = this.givemeEntraProp('givenName'); //this.oa.givenName;
              this.lastname = this.givemeEntraProp('sn'); //this.oa.sn; //THIS HAS CHANGED
              this.fordJobRole = this.givemeEntraProp('fordJobRole'); //this.oa.fordJobRole;
              if(this.fordJobRole === '' || !this.fordJobRole )
        {
                this.fordJobRole = this.givemeEntraProp('employeeType'); //this.oa.employeeType; //HAS THIS CHANGED???
        }

              this.CDSID = this.givemeEntraProp('CDSID'); //this.oa.CDSID;
              if(this.fordJobRole === "f" || this.fordJobRole === "a" || this.fordJobRole === "omsc" || this.fordJobRole === "F" || this.fordJobRole === "A" || this.fordJobRole === "OMSC" || this.fordJobRole === "J" || this.fordJobRole === "j" || this.fordJobRole === "M" || this.fordJobRole === "m" || this.fordJobRole === "W" || this.fordJobRole === "w")
        {
            //USED WHEN NOT LOADING UNIQUE IDS FOR EMPLOYEES
                  this.loginID = this.fordJobRole;
            
            //USED WHEN WE ARE LOADING EMPLOYEE IDS AND ONLY ONES LOADED CAN ATTEND
                  this.loginID = this.CDSID;
        }
        else
        {
          //USED FOR DEALER LOGIN; ALWAYS NEEDED
                this.loginID = this.fordSiteCode;
        }

        this.forward();

        },
        error: err=>{
          this.logService.info(JSON.stringify(err),this.environmentService.sitename+':front.oauth.70').subscribe();
          console.error("serviceurl ",serviceurl);
          console.error("error on service/oauth/ ",err);
          this.persistenceService.clear();
          this.router.navigate(['/instructions']);
        }
      });

      }else{
        this.isSubmitting = false;
        this.errorMsg = "Login not set!";
        this.logService.info("oauth - param code not provided, It is not possible to create the serviceurl ",this.environmentService.sitename+':front.oauth.65').subscribe();

      }
    });

  }

  /**
   * @function givemeEntraProp
   * @description Returns the value of an ENTRA property regardless of uppercase or lowercase letters.
   * @param propertyName string, property name.
   */
  givemeEntraProp(propertyName:string){
    let val=null;
    if( this.oaLowerProps && Object.keys(this.oaLowerProps).includes(propertyName.toLowerCase())){
      let prop= this.oaLowerProps[propertyName.toLowerCase()];
      val= this.oa[prop];
    }else{
      console.error(`the property: [${propertyName}] does not exist in the ENTRA response.`);
      // let otr=btoa(this.firstname+':'+this.lastname+':'+this.cookieLogin+':'+this.userIDCookie+':'); 
      this.logService.info(`the property: [${propertyName}] does not exist in the ENTRA response.`,this.environmentService.sitename+':front.oauth.129').subscribe();
    }
    return val;
  }

  forward() {
    this.persistenceService.testStorage();
    this.persistenceService.clear();
    const creds: any = {};
    creds.username = this.loginID;
    creds.password = 'password';
   // creds.fordId = this.userIDCookie;
    if (this.loginID) {
      this.authenticationService.oauthlogin(creds, this.CDSID).then(() => { 
        // promise resolved
        this.navigationService.forward();
      }, (err) => {
        this.isSubmitting =false;
        this.errorMsg = err;
      });
    } else {
      this.isSubmitting =false;
      this.errorMsg = "Login not set!!";
      let otr=btoa(this.firstname+':'+this.fordSiteCode+':'+this.CDSID+':');
      this.logService.info("oauth LID issue -  Ent property is missing err: "+otr,this.environmentService.sitename+':front.oauth.147').subscribe();
    }

  }

}
